import React from 'react';
import { Link } from 'react-router-dom';

import Shape from '../../assets/img/service/sv-item-shape-1.png';
import Image from '../../assets/img/service/sv-icon-shape-1.png';

const SingleService = (props) => {
  const {
    itemClass,
    titleClass,
    descClass,
    shapeImg,
    serviceIcon,
    serviceIconBg,
    Title,
    Description,
    btnText,
    btnURL,
    btnClass,
  } = props;

  // Only render links if btnURL is explicitly provided
  const hasLink = btnURL && btnURL !== '';

  return (
    <div
      className={
        itemClass
          ? itemClass
          : 'service__item service__border-1  p-relative fix'
      }
    >
      <div className="service__shape">
        <img src={Shape ? Shape : shapeImg} alt="" />
      </div>
      <div className="service__icon-wrapper pb-25 p-relative">
        <div className="service__icon-bg">
          <img src={serviceIconBg ? serviceIconBg : Image} alt="" />
        </div>
        <div className="service__inner-icon">
          <span>
            <i className={serviceIcon ? serviceIcon : 'fal fa-plug'}></i>
          </span>
        </div>
      </div>
      <div className="service__content">
        <h4
          className={titleClass ? titleClass : 'service__title title-color-1'}
        >
          {hasLink ? (
            <Link to={`/${btnURL}`}>
              {Title ? Title : 'Get Latest Updates'}
            </Link>
          ) : (
            <span>{Title ? Title : 'Get Latest Updates'}</span>
          )}
        </h4>
        <p className={descClass ? descClass : ''}>
          {Description
            ? Description
            : 'Business building it before the tab providet management, Payroll & Worksite Services full-fledged.'}
        </p>
      </div>
      {hasLink && (
        <div
          className={btnClass ? btnClass : 'service__link service__link-color-1'}
        >
          <Link to={`/${btnURL}`}>
            {btnText ? btnText : 'Read More'}
            <i className="fal fa-arrow-right"></i>
          </Link>
        </div>
      )}
    </div>
  );
};

export default SingleService;
